module.exports = {
	"ha": "bc",
	"id": 5.7,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2018 Q3–2020 Q2",
		"lastYear": "2020",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 60,
			"marginLeft": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 5.7</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by Health Authority, Year Ending 2020 Q2 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -145,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 98.55134213890072,
						"dataLabels": {
							"enabled": true,
							"format": "2313"
						}
					},
					{
						"y": 86.74904132935663,
						"dataLabels": {
							"enabled": true,
							"format": "2036"
						}
					},
					{
						"y": 82.53089049850874,
						"dataLabels": {
							"enabled": true,
							"format": "1937"
						}
					},
					{
						"y": 76.6084363016617,
						"dataLabels": {
							"enabled": true,
							"format": "1798"
						}
					},
					{
						"y": 57.648061354921175,
						"dataLabels": {
							"enabled": true,
							"format": "1353"
						}
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": true,
							"format": "665"
						}
					},
					{
						"y": 82.85714285714286,
						"dataLabels": {
							"enabled": true,
							"format": "551"
						}
					},
					{
						"y": 80.6015037593985,
						"dataLabels": {
							"enabled": true,
							"format": "536"
						}
					},
					{
						"y": 75.33834586466165,
						"dataLabels": {
							"enabled": true,
							"format": "501"
						}
					},
					{
						"y": 48.87218045112782,
						"dataLabels": {
							"enabled": true,
							"format": "325"
						}
					},
					{
						"y": null
					},
					{
						"y": 96.64429530201343,
						"dataLabels": {
							"enabled": true,
							"format": "288"
						}
					},
					{
						"y": 82.5503355704698,
						"dataLabels": {
							"enabled": true,
							"format": "246"
						}
					},
					{
						"y": 78.18791946308725,
						"dataLabels": {
							"enabled": true,
							"format": "233"
						}
					},
					{
						"y": 68.79194630872483,
						"dataLabels": {
							"enabled": true,
							"format": "205"
						}
					},
					{
						"y": 33.557046979865774,
						"dataLabels": {
							"enabled": true,
							"format": "100"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.84349969192853,
						"dataLabels": {
							"enabled": true,
							"format": "4764"
						}
					},
					{
						"y": 85.04826453070446,
						"dataLabels": {
							"enabled": true,
							"format": "4141"
						}
					},
					{
						"y": 79.62620661326761,
						"dataLabels": {
							"enabled": true,
							"format": "3877"
						}
					},
					{
						"y": 74.43006777572396,
						"dataLabels": {
							"enabled": true,
							"format": "3624"
						}
					},
					{
						"y": 57.89689874717601,
						"dataLabels": {
							"enabled": true,
							"format": "2819"
						}
					},
					{
						"y": null
					},
					{
						"y": 99.38380281690141,
						"dataLabels": {
							"enabled": true,
							"format": "1129"
						}
					},
					{
						"y": 89.52464788732394,
						"dataLabels": {
							"enabled": true,
							"format": "1017"
						}
					},
					{
						"y": 86.00352112676056,
						"dataLabels": {
							"enabled": true,
							"format": "977"
						}
					},
					{
						"y": 79.48943661971832,
						"dataLabels": {
							"enabled": true,
							"format": "903"
						}
					},
					{
						"y": 54.84154929577465,
						"dataLabels": {
							"enabled": true,
							"format": "623"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -1.4486578610992784,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.975789018590577,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.862475442043223,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.176045431078992,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -24.749721913236932,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.14285714285714,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.722323049001818,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.529850746268662,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -35.12974051896207,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.3557046979865723,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.583333333333337,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.284552845528456,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.017167381974247,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -51.21951219512195,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.156500308071474,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.077246011754829,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.375271673508809,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.525664173329893,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.21302428256071,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.616197183098588,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.920283436669619,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.9331366764995046,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.5742067553735914,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -31.007751937984494,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "Fraser Health<br>n=2347"
			},
			{
				"x": 9,
				"text": "Interior Health<br>n=665"
			},
			{
				"x": 15,
				"text": "Northern Health<br>n=298"
			},
			{
				"x": 21,
				"text": "Vancouver Coastal Health<br>n=4869"
			},
			{
				"x": 27,
				"text": "Vancouver Island Health<br>n=1136"
			}
		],
		"dataTable": {
			"Fraser Health": [
				2347,
				2313,
				2036,
				1937,
				1798,
				1353
			],
			"Interior Health": [
				665,
				665,
				551,
				536,
				501,
				325
			],
			"Northern Health": [
				298,
				288,
				246,
				233,
				205,
				100
			],
			"Vancouver Coastal Health": [
				4869,
				4764,
				4141,
				3877,
				3624,
				2819
			],
			"Vancouver Island Health": [
				1136,
				1129,
				1017,
				977,
				903,
				623
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_7.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_5_7.json
// module id = 172
// module chunks = 0